import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppFacade } from '@app/app.facade';
import { Observable } from 'rxjs';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(private appFacade: AppFacade) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.headers.has('X-Skip-Interceptor')) {
      const headers = req.headers.delete('X-Skip-Interceptor');
      return next.handle(req.clone({ headers }));
    }

    if (req.headers.has('x-hohr-language-alpha2code')) {
      return next.handle(req);
    }

    const i18nLanguage = this.appFacade.currentLanguage;

    if (i18nLanguage) {
      return next.handle(
        req.clone({
          setHeaders: {
            'x-hohr-language-alpha2code': i18nLanguage,
          },
        })
      );
    }

    return next.handle(req);
  }
}
